module.exports = __webpack_public_path__ + "static/media/Group45.ed320b67.svg";